module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [_c('v-slide-y-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.toastShow.time,
      "color": _vm.toastShow.color,
      "top": true,
      "right": true
    },
    model: {
      value: (_vm.toastShow.visibility),
      callback: function($$v) {
        _vm.$set(_vm.toastShow, "visibility", $$v)
      },
      expression: "toastShow.visibility"
    }
  }, [_vm._v("\n   " + _vm._s(_vm.toastShow.text) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-794d3ecc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 353
// module chunks = 43